import { ReactComponent as SuccessIconSVG } from "./success-icon.svg";
import { SvgIcon } from '@mui/material';

export default function IconSuccess(props) {
  return <SvgIcon {...props} component={SuccessIconSVG} viewBox="0 0 117 117" />;
}